import type { routes } from '@semios/app-platform-banyan-route-definitions'
import { getTimezoneForSelectedPropertyOrRegion } from 'App/Map/PanelDetails/_utils/getTimezoneForSelectedPropertyOrRegion'
import { propertyLacksPermissionSectionMaker } from 'App/Map/PanelDetails/_utils/propertyLacksPermissionSectionMaker'
import { selectedPropertyHasPermission } from 'App/Map/PanelDetails/_utils/selectedPropertyHasPermission'
import { DropdownSelectorIrrigationZoneEmitter } from 'App/Map/PanelDetails/SectionTitleBars/DropdownSelectorIrrigationZoneEmitter/DropdownSelectorIrrigationZoneEmitter'
import type { StackedChartSection } from 'components/StackedChart/types'
import { translate } from 'i18n/i18n'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import type { TSelectedFieldAssetsStoreState } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'
import { doesSelectedPointHaveValueTypes } from '../../../../../../../../utils/doesSelectedFieldAssetHaveValueTypes'
import { chooseAmongstUnAggHourlyAndDaily } from '../../../chooseAmongstUnAggHourlyAndDaily'
import { zoneEmitterLacksPermissionSectionMaker } from '../_utils/zoneEmitterLacksPermissionSectionMaker'
import { getActivityIntervalsFromData } from './_utils/getActivityIntervalsFromData'
import { getChartDataWithPressureAndActivity } from './_utils/getChartDataWithPressureAndActivity'

const checkPermission = () => selectedPropertyHasPermission({ permission: 'VIEW_IRRIGATION_DETAILS' })

export const pressureSensorsChart = ({
  data,
  selectedFieldAssets,
}: {
  data: routes.Values.Response
  selectedFieldAssets: TSelectedFieldAssetsStoreState
}): StackedChartSection | null => {
  const title = translate.phrases.banyanApp('Irrigation Activity by Pressure Sensors')

  const commonReturnItems: Pick<StackedChartSection, 'id' | 'title' | 'fieldAssetPicker'> = {
    title,
    fieldAssetPicker: <DropdownSelectorIrrigationZoneEmitter isPressureSensor={true} />,
    id: 'stackem-pressure-sensors-chart',
  }

  if (!checkPermission()) return propertyLacksPermissionSectionMaker(commonReturnItems)

  const { property: propertyId, pressureTransducerPoint } = selectedFieldAssets
  const { properties } = fieldAssetStore.getState()
  const property = properties?.[Number(propertyId)]
  const ptPoint = pressureTransducerPoint && property?.points?.[pressureTransducerPoint]

  if (
    !ptPoint ||
    !doesSelectedPointHaveValueTypes({
      valuesTimeseries: ptPoint.valuesTimeseries,
      pointCategory: 'pressureTransducerPoint',
    })
  )
    return zoneEmitterLacksPermissionSectionMaker({ ...commonReturnItems, name: 'zone' })

  return getChartDataWithPressureAndActivity({
    activityIntervals: getActivityIntervalsFromData({ data, selectedFieldAssets }),
    property: propertyId,
    data,
    selectedFieldAssets,
    timezone: getTimezoneForSelectedPropertyOrRegion({ properties, propertyId }),
    showPressure: chooseAmongstUnAggHourlyAndDaily({ excludeFuture: true }) !== 'DAILY',
    commonReturnItems,
  })
}
